export default {
    name: {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 25
      }
    }
};
  
